interface ShareIconProps {
  size?: number
  color?: string
}

export function ShareIcon({ size = 24, color = '#60a5fa' }: ShareIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top right circle */}
      <circle cx="18" cy="5" r="3" fill={color} />
      {/* Middle left circle */}
      <circle cx="6" cy="12" r="3" fill={color} />
      {/* Bottom right circle */}
      <circle cx="18" cy="19" r="3" fill={color} />
      {/* Lines connecting circles */}
      <line x1="8.5" y1="10.5" x2="15.5" y2="6.5" stroke={color} strokeWidth="2" />
      <line x1="8.5" y1="13.5" x2="15.5" y2="17.5" stroke={color} strokeWidth="2" />
    </svg>
  )
}
